import React, { useEffect, useRef, useState } from "react";
import { ModalAlert } from "../../common/dialog/modalAlert";
import { adicionarPontosMilhar } from "../../utils/adicionarPontosMilhar";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { gerarRelatorio, gerarXlsx, getListaBalancoEnergetico } from "../geracaoLeituraActions";
import { setError } from "../../common/toast/toast";
import casaRemota from "../../assets/images/casaRemota.png";
import solVerde from "../../assets/images/solVerde.png";
import solVermelho from "../../assets/images/solVermelho.png";
import { RowFlex } from "../../common/layout/RowFlex";
import Grid from "../../common/layout/grid.jsx";
import { BotaoGerarRelatorio } from "../../common/button/BotaoGerarRelatorio";
import { convertToBase64 } from "../../utils/convertToBase64";
import { Loading } from "../../common/loading/loading";
import { TabelaSaldosFatura } from "../../fatura/components/TabelaSaldosFatura.jsx";

const isMobile = window.innerWidth <= 768;

function ModalBalancoEnergeticoComponent(props) {
    if (!props.visible || props.pdf) return null;

    if (typeof props.itemSelecionado !== "object" || !props.itemSelecionado.id_cliente || !props.itemSelecionado.id_unidade_consumidora) {
        setError("Registro Inválido");
        return null;
    }

    const periodoInicial = extrairMesAno(props);

    if (!periodoInicial.mes || !periodoInicial.ano) {
        setError("Período Inválido");
        return null;
    }

    const [periodoSelecionado, setPeriodoSelecionado] = useState(periodoInicial);
    const contentCardRef = useRef(null);
    const { mes, ano } = periodoSelecionado;

    useEffect(() => {
        const novoPeriodoInicial = extrairMesAno(props);
        if (novoPeriodoInicial.mes && novoPeriodoInicial.ano) {
            setPeriodoSelecionado(novoPeriodoInicial);
        }
    }, [props.itemSelecionado, props.usarDatahoraMesAnterior]);

    useEffect(() => {
        if (!mes || !ano || ehPeriodoFuturo(periodoSelecionado)) return;

        props.getListaBalancoEnergetico({
            id_cliente: props.itemSelecionado.id_cliente,
            id_unidade_geradora: props.itemSelecionado.id_unidade_consumidora,
            ano,
            mes,
        });
    }, [props.itemSelecionado, ano, mes]);

    const unidadeGeradora = props.listaBalancoEnergetico.find((item) => item.unidade_geradora);
    const unidadesRemotas = props.listaBalancoEnergetico.filter((item) => !item.unidade_geradora);

    const widthCabecalho = "20%";
    const widthDescricao = "50%";
    const widthQuantidade = "15%";
    const widthValor = "15%";

    const titulo = `Balanço Energético ${mes}/${ano}`;
    const estiloTotalizador = { fontWeight: "bold", background: "#224d7c", color: "#FFF" };
    const bloquearAvancar = ehPeriodoAtualOuFuturo(periodoSelecionado);

    function alterarPeriodo(quantidadeMeses) {
        const novaData = new Date(Number(ano), Number(mes) - 1 + quantidadeMeses, 1);
        const mesAjustado = novaData.getMonth() + 1;
        const novoPeriodo = {
            ano: novaData.getFullYear(),
            mes: (mesAjustado < 10 ? "0" : "") + mesAjustado,
        };

        if (ehPeriodoFuturo(novoPeriodo)) {
            setError("Não é permitido buscar período superior ao mês atual");
            return;
        }

        setPeriodoSelecionado(novoPeriodo);
    }

    async function handleGerarPdf() {
        if (!contentCardRef.current) return;

        const tabelas = contentCardRef.current.querySelectorAll("table");

        tabelas.forEach((tabela) => {
            tabela.style.borderCollapse = "collapse";
            tabela.style.border = "1px solid #222";

            const celulas = tabela.querySelectorAll("td, th");

            celulas.forEach((c) => {
                c.style.border = "1px solid #222";
            });
        });
        // Altera a largura e cor de fundo do gráfico antes de renderizar o conteúdo
        const tabelaBalancoEnergetico = contentCardRef.current;

        // formatarTabela({ el: tabelaTarifaMediaMensalGeral });

        const tituloCabecalho = props.itemSelecionado.nome_cliente;
        const competencia = `${mes}/${ano}`;
        const base64Cabecalho = await convertToBase64("/images/cabecalho_relatorio.png");
        const htmlCabecalho = `<div style="border: 1px solid #DDD"><div style="width:100%; height:10%;font-family: Arial, sans-serif;">
                                    <img src="${base64Cabecalho}" width="100%" />
                                     <div style="width:100%; display:flex;margin-top:-45px;color:#FFF">
                                            <div style="width:80%; display:flex; justify-content:flex-start">
                                            <h5 style="padding-left:5px;">${tituloCabecalho}</h5>
                                            </div>
                                            <div style="width:20%; display:flex; justify-content:flex-end">
                                             <h5 style="padding-right:5px;">${competencia}</h5>
                                            </div>
                                        </div>
                                </div>`;

        const base64Rodape = await convertToBase64("/images/rodape_relatorio.png");
        const htmlRodape = `<div style="width:100%; height:5%; display:flex; flex-direction:column; align-items:center; justify-content:flex-end;">
                                        <img src="${base64Rodape}" width="100%" />
                                    </div>`;

        // Captura o HTML com os estilos atualizados
        const htmlTabelaBalancoEnergetico =
            `<div style="width:100%; height:84%; display:flex; flex-direction:column; align-items:center; justify-content:flex-start; margin-bottom:10px; background-color:#FFF">` +
            tabelaBalancoEnergetico.outerHTML +
            "</div>";
        let html = htmlCabecalho + htmlTabelaBalancoEnergetico + htmlRodape;
        props.gerarRelatorio({ html, landscape: false, scale: 0.9 });
    }
    function handleGerarXlsx() {
        //criar função que faz download múltiplo

        const linhaEmBranco = {
            Tipo: "",
            "Status Importação": "",
            UC: "",
            Mês: "",
            Descrição: "",
            kWh: "",
            R$: "",
        };

        const dadosGeradora = [
            {
                Descrição: "Produziu",
                kWh: adicionarPontosMilhar(unidadeGeradora.quantidade_geracao || 0),
                R$: adicionarPontosMilhar(parseFloat(unidadeGeradora.quantidade_geracao || 0) * parseFloat(unidadeGeradora.tarifa_consumo_instantaneo || 0)),
            },
            {
                Descrição: "Injetou",
                kWh: adicionarPontosMilhar(unidadeGeradora.energia_excedente || 0),
                R$: "N/A",
            },
            {
                Descrição: "Consumo Total",
                kWh: adicionarPontosMilhar(unidadeGeradora.energia || 0),
                R$: adicionarPontosMilhar(parseFloat(unidadeGeradora.valor_fatura || 0)),
            },
            {
                Descrição: "Economizou Instantaneamente",
                kWh: adicionarPontosMilhar(unidadeGeradora.consumo_instantaneo || 0),
                R$: adicionarPontosMilhar(parseFloat(unidadeGeradora.valor_consumo_instantaneo || 0)),
            },
            {
                Descrição: "Economizou na Fatura",
                kWh: adicionarPontosMilhar(unidadeGeradora.quantidade_economia || 0),
                R$: adicionarPontosMilhar(parseFloat(unidadeGeradora.valor_economia || 0)),
            },
            {
                Descrição: "Economizou do Saldo Preexistente",
                kWh: adicionarPontosMilhar(unidadeGeradora.quantidade_saldo_preexistente || 0),
                R$: adicionarPontosMilhar(parseFloat(unidadeGeradora.valor_saldo_preexistente || 0)),
            },
            {
                Descrição: "Economizou em Bandeiras",
                kWh: "N/A",
                R$: adicionarPontosMilhar(parseFloat(unidadeGeradora.valor_bandeira_economia || 0)),
            },
            {
                Descrição: "Total Economizado",
                kWh: adicionarPontosMilhar(parseFloat(unidadeGeradora.quantidade_economia || 0) + parseFloat(unidadeGeradora.consumo_instantaneo || 0)),
                R$: adicionarPontosMilhar(parseFloat(unidadeGeradora.valor_economia || 0) + parseFloat(unidadeGeradora.valor_consumo_instantaneo || 0)),
            },
        ].map((item) => ({
            Tipo: `GERADORA FV${unidadeGeradora.sequencia_uc_geradora}`,
            "Status Importação": parseFloat(unidadeGeradora.quantidade_geracao || 0) <= 0 ? "Importação Solar Pendente" : "Geração Solar Importada",
            UC: `${unidadeGeradora.nome_unidade_consumidora}`,
            Mês: `${mes}/${ano}`,
            ...item,
        }));

        const dados = [...dadosGeradora];
        if (unidadesRemotas.length) {
            dados.push(linhaEmBranco);

            unidadesRemotas.forEach((item) => {
                const linhas = [
                    {
                        Descrição: "Consumiu Total",
                        kWh: adicionarPontosMilhar(item.energia_total || 0),
                        R$: adicionarPontosMilhar(parseFloat(item.valor_fatura || 0) + parseFloat(item.valor_economia || 0)),
                    },
                    {
                        Descrição: "Economizou na Fatura (Recebeu)",
                        kWh: adicionarPontosMilhar(item.quantidade_economia_fatura || 0),
                        R$: adicionarPontosMilhar(item.valor_economia_fatura || 0),
                    },
                    {
                        Descrição: "Economizou do Saldo Preexistente",
                        kWh: adicionarPontosMilhar(item.quantidade_saldo_preexistente || 0),
                        R$: adicionarPontosMilhar(item.valor_saldo_preexistente || 0),
                    },
                    {
                        Descrição: "Economizou em Bandeiras",
                        kWh: "N/A",
                        R$: adicionarPontosMilhar(parseFloat(item.valor_bandeira_economia || 0)),
                    },
                    {
                        Descrição: "Total Economizado",
                        kWh: adicionarPontosMilhar(
                            parseFloat(item.quantidade_economia || 0) + parseFloat(item.consumo_instantaneo || 0) + parseFloat(item.quantidade_economia_fatura || 0)
                        ),
                        R$: adicionarPontosMilhar(
                            parseFloat(item.valor_economia || 0) + parseFloat(item.valor_consumo_instantaneo || 0) + parseFloat(item.valor_economia_fatura || 0)
                        ),
                    },
                ].map((linha) => ({
                    Tipo: `REMOTA FV${item.sequencia_uc_geradora}`,
                    "Status Importação": parseFloat(item.energia_total || 0) <= 0 ? "Importação Consumo Pendente" : "Consumo Importado",
                    UC: `${item.nome_unidade_consumidora}`,
                    Mês: `${mes}/${ano}`,
                    ...linha,
                }));

                dados.push(...linhas);
                dados.push(linhaEmBranco);
            });
        }
        props.gerarXlsx({ nomeArquivo: `Balanço Energético ${mes}_${ano}`, dados });
    }

    return props.aguardando ? (
        <Loading />
    ) : (
        <ModalAlert titulo={titulo} handleClose={props.handleClose}>
            <RowFlex style={{ justifyContent: "center", alignItems: "center", gap: "10px", marginBottom: "8px" }}>
                <button type="button" className="btn btn-sm btn-outline-secondary" title="Mês anterior" onClick={() => alterarPeriodo(-1)}>
                    <i className="fas fa-chevron-left" />
                </button>
                <strong style={{ minWidth: 75, textAlign: "center" }}>
                    {mes}/{ano}
                </strong>
                <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary"
                    title={bloquearAvancar ? "Não é permitido buscar período superior ao mês atual" : "Próximo mês"}
                    disabled={bloquearAvancar}
                    onClick={() => alterarPeriodo(1)}
                >
                    <i className="fas fa-chevron-right" />
                </button>
            </RowFlex>
            <RowFlex style={{ justifyContent: "center", gap: "10px", marginBottom: "8px" }}>
                {unidadeGeradora ? (
                    <Grid cols="12 5 5 3">
                        <BotaoGerarRelatorio aguardando={props.aguardando} gerarPdf={handleGerarPdf} gerarXlsx={handleGerarXlsx} />
                    </Grid>
                ) : null}
            </RowFlex>
            {!unidadeGeradora ? <div className="text-center py-3">Nenhum balanço energético encontrado para este período.</div> : null}
            <div
                ref={contentCardRef}
                style={{
                    width: "100%",
                    overflowX: isMobile ? "auto" : "visible",
                }}
            >
                {!unidadeGeradora ? null : (
                    <>
                <table
                    border="1"
                    style={{
                        width: "100%",
                        borderCollapse: "collapse",
                    }}
                >
                    <thead>
                        <tr style={{ backgroundColor: "#ffc300", wordbreak: "break-word" }}>
                            <th>GERADORA</th>
                            <th>Descrição</th>
                            <th>kWh</th>
                            <th>R$</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td width={widthCabecalho} rowSpan={8}>
                                <div
                                    style={{
                                        textAlign: "center",
                                        filter: "brightness(1.5)",
                                    }}
                                    title={parseFloat(unidadeGeradora.quantidade_geracao || 0) <= 0 ? "Importação Solar Pendente" : "Geração Solar Importada"}
                                >
                                    {parseFloat(unidadeGeradora.quantidade_geracao || 0) <= 0 ? (
                                        <img alt="" height={24} style={{ marginBottom: 6, marginRight: 3 }} src={solVermelho} />
                                    ) : (
                                        <img alt="" height={24} style={{ marginBottom: 6, marginRight: 3 }} src={solVerde} />
                                    )}
                                    <span> - FV{unidadeGeradora.sequencia_uc_geradora}</span>
                                    <div className="pl-2">{unidadeGeradora.nome_unidade_consumidora}</div>
                                </div>
                                <div className="d-flex justify-content-center py-2">
                                    <TabelaSaldosFatura item={unidadeGeradora} pillMode={true} />
                                </div>
                            </td>
                            <td width={widthDescricao}>Produziu</td>
                            <td width={widthQuantidade}>{adicionarPontosMilhar(unidadeGeradora.quantidade_geracao || 0)}</td>
                            <td width={widthValor}>
                                {adicionarPontosMilhar(parseFloat(unidadeGeradora.quantidade_geracao || 0) * parseFloat(unidadeGeradora.tarifa_consumo_instantaneo || 0))}
                            </td>
                        </tr>
                        <tr>
                            <td width={widthDescricao}>Injetou</td>
                            <td width={widthQuantidade}>{adicionarPontosMilhar(unidadeGeradora.energia_excedente || 0)}</td>
                            <td width={widthValor}>N/A</td>
                        </tr>
                        <tr>
                            <td width={widthDescricao}>Consumo Total</td>
                            <td width={widthQuantidade}>{adicionarPontosMilhar(unidadeGeradora.energia || 0)}</td>
                            <td width={widthValor}>{adicionarPontosMilhar(parseFloat(unidadeGeradora.valor_fatura || 0))}</td>
                        </tr>
                        <tr>
                            <td width={widthDescricao}>Economizou Instantaneamente</td>
                            <td width={widthQuantidade}>{adicionarPontosMilhar(unidadeGeradora.consumo_instantaneo || 0)}</td>
                            <td width={widthValor}>{adicionarPontosMilhar(parseFloat(unidadeGeradora.valor_consumo_instantaneo || 0))} </td>
                        </tr>
                        <tr>
                            <td width={widthDescricao}>Economizou na Fatura</td>
                            <td width={widthQuantidade}>{adicionarPontosMilhar(unidadeGeradora.quantidade_economia || 0)}</td>
                            <td width={widthValor}>{adicionarPontosMilhar(parseFloat(unidadeGeradora.valor_economia || 0))} </td>
                        </tr>
                        <tr>
                            <td width={widthDescricao}>Economizou do Saldo Preexistente</td>
                            <td width={widthQuantidade}>{adicionarPontosMilhar(unidadeGeradora.quantidade_saldo_preexistente || 0)}</td>
                            <td width={widthValor}>{adicionarPontosMilhar(parseFloat(unidadeGeradora.valor_saldo_preexistente || 0))}</td>
                        </tr>
                        <tr>
                            <td width={widthDescricao}>Economizou em Bandeiras</td>
                            <td width={widthQuantidade}>N/A</td>
                            <td width={widthValor}>{adicionarPontosMilhar(parseFloat(unidadeGeradora.valor_bandeira_economia || 0))}</td>
                        </tr>

                        <tr style={estiloTotalizador}>
                            <td width={widthDescricao}>Total Economizado</td>
                            <td width={widthQuantidade} title="Soma das Energias (Cons.Inst + Cons. Fatura)">
                                {adicionarPontosMilhar(parseFloat(unidadeGeradora.quantidade_economia || 0) + parseFloat(unidadeGeradora.consumo_instantaneo || 0))}
                            </td>
                            <td width={widthValor} title="Soma Economias Fatura (incluindo banteiras, etc)">
                                {adicionarPontosMilhar(parseFloat(unidadeGeradora.valor_economia || 0) + parseFloat(unidadeGeradora.valor_consumo_instantaneo || 0))}
                            </td>
                        </tr>
                    </tbody>
                </table>
                {unidadesRemotas.length ? (
                    <>
                        <hr></hr>
                        <table border="1" width={"100%"}>
                            <thead>
                                <tr style={{ backgroundColor: "#00ff77" }}>
                                    <th>REMOTAS</th>
                                    <th>Descrição</th>
                                    <th>kWh</th>
                                    <th>R$</th>
                                </tr>
                            </thead>
                            {unidadesRemotas.map((item, i) => {
                                return (
                                    <tbody key={item.id} style={{ backgroundColor: i % 2 == 0 ? "#FFF" : "#d8ffeb" }}>
                                        <tr>
                                            <td width={widthCabecalho} rowSpan={5}>
                                                <div style={{ textAlign: "center" }}>
                                                    <img alt="" height={24} style={{ marginBottom: 6, marginRight: 3 }} src={casaRemota}></img>
                                                    <span> - FV{item.sequencia_uc_geradora}</span>
                                                    <div className="pl-2">{item.nome_unidade_consumidora}</div>
                                                </div>
                                                <div className="d-flex justify-content-center py-2">
                                                    <TabelaSaldosFatura item={item} pillMode={true} />
                                                </div>
                                            </td>
                                            <td width={widthDescricao}>Consumiu Total</td>
                                            <td width={widthQuantidade}>{adicionarPontosMilhar(item.energia_total || 0)}</td>
                                            <td width={widthValor}> {adicionarPontosMilhar(parseFloat(item.total || 0) + parseFloat(item.valor_economia || 0))}</td>
                                        </tr>
                                        <tr>
                                            <td width={widthDescricao}>Economizou na Fatura (Recebeu)</td>
                                            <td width={widthQuantidade}>{adicionarPontosMilhar(item.quantidade_economia_fatura || 0)}</td>
                                            <td width={widthValor}>{adicionarPontosMilhar(item.valor_economia_fatura || 0)}</td>
                                        </tr>
                                        <tr>
                                            <td width={widthDescricao}>Economizou do Saldo Preexistente</td>
                                            <td width={widthQuantidade}>{adicionarPontosMilhar(item.quantidade_saldo_preexistente || 0)}</td>
                                            <td width={widthValor}>{adicionarPontosMilhar(item.valor_saldo_preexistente || 0)}</td>
                                        </tr>
                                        <tr>
                                            <td width={widthDescricao}>Economizou em Bandeiras</td>
                                            <td width={widthQuantidade}>N/A</td>
                                            <td width={widthValor}>{adicionarPontosMilhar(parseFloat(item.valor_bandeira_economia || 0))}</td>
                                        </tr>
                                        <tr style={estiloTotalizador}>
                                            <td width={widthDescricao}>Total Economizado</td>
                                            <td width={widthQuantidade} title="Soma das Energias (Cons.Inst + Cons. Fatura)">
                                                {adicionarPontosMilhar(
                                                    parseFloat(item.quantidade_economia || 0) +
                                                        parseFloat(item.consumo_instantaneo || 0) +
                                                        parseFloat(item.quantidade_economia_fatura || 0)
                                                )}
                                            </td>
                                            <td width={widthValor} title="Soma Economias Fatura (incluindo banteiras, etc)">
                                                {adicionarPontosMilhar(
                                                    parseFloat(item.valor_economia || 0) +
                                                        parseFloat(item.valor_consumo_instantaneo || 0) +
                                                        parseFloat(item.valor_economia_fatura || 0)
                                                )}
                                            </td>
                                        </tr>
                                    </tbody>
                                );
                            })}
                        </table>
                    </>
                ) : null}
                    </>
                )}
            </div>
        </ModalAlert>
    );
}

function extrairMesAno(props) {
    let mes = null;
    let ano = null;

    try {
        if (props.itemSelecionado.data_hora) {
            const dataHora = new Date(props.itemSelecionado.data_hora);
            if (props.usarDatahoraMesAnterior) {
                dataHora.setMonth(dataHora.getMonth() - 1);
            }
            ano = dataHora.getFullYear();
            const mesAjustado = dataHora.getMonth() + 1;
            mes = (mesAjustado < 10 ? "0" : "") + mesAjustado;
        } else if (props.itemSelecionado.competencia) {
            mes = String(props.itemSelecionado.competencia).substring(4, 6);
            ano = String(props.itemSelecionado.competencia).substring(0, 4);
        }
        return { mes, ano };
    } catch (erro) {
        return { mes: null, ano: null };
    }
}

function ehPeriodoFuturo(periodo) {
    const hoje = new Date();
    const anoAtual = hoje.getFullYear();
    const mesAtual = hoje.getMonth() + 1;
    const anoPeriodo = Number(periodo.ano);
    const mesPeriodo = Number(periodo.mes);

    return anoPeriodo > anoAtual || (anoPeriodo === anoAtual && mesPeriodo > mesAtual);
}

function ehPeriodoAtualOuFuturo(periodo) {
    const hoje = new Date();
    const anoAtual = hoje.getFullYear();
    const mesAtual = hoje.getMonth() + 1;
    const anoPeriodo = Number(periodo.ano);
    const mesPeriodo = Number(periodo.mes);

    return anoPeriodo > anoAtual || (anoPeriodo === anoAtual && mesPeriodo >= mesAtual);
}

const mapStateToProps = (state) => {
    return {
        aguardando: state.geracaoLeitura.aguardando,
        listaBalancoEnergetico: state.geracaoLeitura.listaBalancoEnergetico,
        pdf: state.displayPDF.pdf,
    };
};
const mapDispatchToProps = (dispatch) => bindActionCreators({ getListaBalancoEnergetico, gerarRelatorio, gerarXlsx }, dispatch);

export const ModalBalancoEnergetico = connect(mapStateToProps, mapDispatchToProps)(ModalBalancoEnergeticoComponent);
